import { useEffect } from "react";
import { Card, Box, Typography, Divider } from "@mui/material";
import { getCurrentTaxDetailsRequest } from "../../../../../redux/inspection-firms/slice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../../../components/loading/loading";

export default function TaxDetails() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrentTaxDetailsRequest());
  }, [dispatch]);

  const { loading, currentTaxDetails } = useSelector(
    (state: any) => state.inspectionFirms
  );

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Tax</Typography>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Name of Entity/Individual
          </Typography>
          <Typography>{currentTaxDetails?.entityName || "-"}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Business Name/DBA (if different from above)
          </Typography>
          <Typography>{currentTaxDetails?.businessName || "-"}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Tax Classification</Typography>
          <Typography>
            {currentTaxDetails?.taxClassificationName || "-"}
          </Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Tax ID Number</Typography>
          <Typography>{currentTaxDetails?.taxIdNumber || "-"}</Typography>
        </Box>
      </Card>
      {loading && <Loading />}
    </>
  );
}
